import React from "react";

function PFFinale({...props}) {
    return (
        <>
            <div className="text-center fs-5">
                Finale performance by:
            </div>
            <div className="text-center fs-2">
                <strong>The Blues Chasers</strong>
            </div>
            <div className="text-center fs-5">
                at The Griffin Museum Terrace at 5:30pm.
            </div>
        </>
    );
}

export default PFFinale;
